import { useEffect } from 'react';

function Bidra() {
  useEffect(() => {
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('fade-in-up');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.bidra-block')
      .forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const scrollToContact = (e) => {
    e.preventDefault();
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div className="bidra-page">
      {/* Hero */}
      <section className="bidra-hero">
        <div className="container">
          <div className="bidra-hero-text">
            <span className="section-tag">St&ouml;d oss</span>
            <h1>Varje bidrag g&ouml;r skillnad.</h1>
            <p>
              Allt vi g&ouml;r &auml;r m&ouml;jligt tack vare generositeten fr&aring;n
              m&auml;nniskor som du. H&auml;r &auml;r n&aring;gra s&auml;tt du kan hj&auml;lpa till.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="bidra-content">
        <div className="container">
          <div className="bidra-block">
            <span className="bidra-number">01</span>
            <h2>Ekonomiskt st&ouml;d</h2>
            <p>
              Ditt st&ouml;d g&aring;r direkt till mat, fika och g&aring;vor vid v&aring;ra event.
              F&ouml;retag kan ocks&aring; sponsra - vi lyfter g&auml;rna fram v&aring;ra partners.
            </p>
            <a
              href="https://www.gofundme.com/f/hjalp-oss-skapa-ett-kostnadsfritt-midsommarfirande-for-manni"
              target="_blank"
              rel="noopener noreferrer"
              className="bidra-link"
            >
              Donera via GoFundMe &rarr;
            </a>
          </div>

          <div className="bidra-block">
            <span className="bidra-number">02</span>
            <h2>Donera varor &amp; tj&auml;nster</h2>
            <p>
              Bidra genom att sk&auml;nka varor eller tj&auml;nster - mat, g&aring;vor,
              kl&auml;der, musik eller utrustning. Allt g&ouml;r skillnad.
            </p>
            <a href="#contact" onClick={scrollToContact} className="bidra-link">
              Kontakta oss &rarr;
            </a>
          </div>

          <div className="bidra-block">
            <span className="bidra-number">03</span>
            <h2>Sprid ordet</h2>
            <p>
              Dela med v&auml;nner, i sociala medier eller tipsa organisationer.
              Ju fler som vet, desto fler kan vi n&aring;.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Bidra;
